import { cn } from '../../lib/cn';
import { useNavigate, useLocation } from 'react-router-dom';
import { Settings2 } from 'lucide-react';

export function ReviewModeHandle({ className }: { className?: string }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // Preserve current query params when returning to review mode
    navigate(`/${location.search}`);
  };

  return (
    <button
      data-testid="review-mode-handle"
      onClick={handleClick}
      className={cn(
        'fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2.5 text-sm font-medium text-white shadow-elevation-4 transition-transform hover:scale-105 focus-visible:ring-2 focus-visible:ring-park-500 focus-visible:ring-offset-2',
        className
      )}
    >
      <Settings2 className="h-4 w-4" />
      Review Mode
    </button>
  );
}
